export const MOVE_WORKFLOW_FUND_DETAILS = "/fund/create-envelope/";
export const MOVE_WORKFLOW_DASHBOARD = "/workflows/member-workflows/:workflow_id/create-envelope/";
